import env from './env';

export const fetchStatus = async (token) => {
  return await fetch(env('REACT_APP_BACKEND_URL') + '/v1/status', {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  })
    .then((response) => {
      // 200
      if (response.ok) {
        return response.json();
      }
      // ?
      throw response.json();
    })
    .catch((error) => {
      if (error instanceof TypeError) {
        throw new Error(error.message);
      }
      return error.then((text) => {
        throw new Error(text['detail']);
      });
    });
};

export const login = async (username, password) => {
  const loginObj = {
    username: username,
    password: password,
  };

  return await fetch(env('REACT_APP_BACKEND_URL') + '/v1/login', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(loginObj),
  })
    .then((response) => {
      // 200
      if (response.ok) {
        return response.json();
      }
      // 401 - 500
      throw response.json();
    })
    .catch((error) => {
      if (error instanceof TypeError) {
        throw new Error(error.message);
      }
      return error.then((text) => {
        throw new Error(text['detail']);
      });
    });
};
